import React, { useCallback, useState } from 'react';
import uniq from 'lodash/uniq';
import styled from '@emotion/styled';
import { Y200 } from '@atlaskit/theme/colors';
import { NoData } from '@css-xp/ppc-common';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { useStore } from '../../../../../../store';
import { EntitlementItemCell, ProductStatusLozenge } from '@css-xp/ppc-purchase-experience';
import { OperationType } from '../../../../../../types';
import { cartLinkedEntitlement, Product } from '../../../../../product-line-items/src/types';

type failureCartApp = cartLinkedEntitlement & {
  cloudSite?: string;
};
type failureProduct = Product & {
  cloudSite?: string;
};

type CartLineItemProps = {
  lineItem: failureCartApp | failureProduct;
  isApp: boolean;
};

const SpacingBeforeIntegratedApps = styled.div({
  padding: '12px',
});

export const FailureProductLineItemRow = ({ lineItem, isApp }: CartLineItemProps) => {
  const [{ selectedLinkedEntitlements }] = useStore();

  const appProductStatuses = isApp ? selectedLinkedEntitlements?.[lineItem.id]?.productStatuses ?? [] : []; // For apps use the updated status from selected app from store
  const productStatuses = uniq([...(lineItem.productStatuses ?? []), ...appProductStatuses]);

  return (
    <tr key={lineItem.id} className="failure-product-rows-container--row">
      <td>
        <div className="failure-product-rows-container--product-wrapper">
          {isApp && lineItem.operationType !== OperationType.NEW && <SpacingBeforeIntegratedApps />}
          <WarningIcon size={'small'} primaryColor={Y200} label="" />
          <EntitlementItemCell
            name={lineItem?.name}
            logoId={lineItem?.logoId}
            productId={lineItem?.productId}
            entitlementNumber={lineItem?.entitlementNumber}
          />
        </div>
      </td>
      <td>{lineItem?.cloudSite ?? <NoData />}</td>
      <td>
        {productStatuses?.map((status) => {
          return (
            <ProductStatusLozenge className="product-status-column" key={`product-status-${status}`} status={status} />
          );
        })}
      </td>
    </tr>
  );
};
